'use strict';

var mcb = mcb || {};
mcb.object = mcb.object || {};

mcb.object.utils = mcb.object.utils || new function () {
    this.init = function() {}
    this.findInObj = function (theObject, propName, propValue) {
        var result = null;
        if(theObject instanceof Array) {
            for(var i = 0; i < theObject.length; i++) {
                result = this.findInObj(theObject[i], propName, propValue);
                if (result) {
                    break;
                }   
            }
        }
        else
        {
            for(var prop in theObject) {
                if(prop.toLowerCase() == propName.toLowerCase()) {
                    if(theObject[prop] == propValue) {
                        return theObject;
                    } else if ((typeof theObject[prop] === 'string' || theObject[prop] instanceof String) && (typeof propValue === 'string' || propValue instanceof String)) {
                        if (theObject[prop].toLowerCase() == propValue.toLowerCase()) {
                            return theObject;
                        }
                    }
                }
                if(theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
                    result = this.findInObj(theObject[prop], propName, propValue);
                    if (result) {
                        break;
                    }
                } 
            }
        }
        return result;
    };
}();